/**
 * Landing page v3 tokens (design_handoff_portal_landing_rail_pro/README.md, "Global" and
 * "Design tokens"). Every number here is the handoff's; sections never retune them.
 */
export const RING_STOPS = ['#FD199F', '#FF33C6', '#B5B1FF', '#127BFD', '#22ECFB', '#FAE1B4', '#FCAA6D'];
export const RING = `linear-gradient(90deg,${RING_STOPS.join(',')},${RING_STOPS[0]})`;
export const RING_135 = 'linear-gradient(135deg,#FD199F,#B5B1FF,#127BFD,#22ECFB,#FCAA6D)';
export const RING_SHORT = 'linear-gradient(90deg,#FD199F,#B5B1FF,#127BFD,#22ECFB,#FCAA6D)';
/** A black pill with the ring as its border — pair with `border: 2px solid transparent`. */
export const RING_ON = `linear-gradient(#000,#000) padding-box, ${RING} border-box`;

export const MAGENTA = '#FF00AA';
export const PINK = '#FF33C6';
export const STARTER = '#FF00FF';
export const CYAN = '#00FFFF';
export const FUND_TRACK = '#FBD5FB';
export const GREEN_LIT = '#16A34A';
export const FUNDING = '#EAB308';
export const SELLING = '#22C55E';
export const MUTED = '#6B7280';
export const SUBTLE = '#9CA3AF';
export const GREY_STEP = '#B3B3B3';
export const GREY_CARD = '#CFCFCF';
export const EYEBROW = '#9A9A9A';
export const RULE_DARK = '#2A2A2A';

export const MONO = "'JetBrains Mono', Menlo, monospace";
export const SERIF = "'Times New Roman', Times, serif";

export const eyebrow = { fontSize: 11, fontWeight: 700, letterSpacing: '.28em', color: EYEBROW, textTransform: 'uppercase' };
export const h2 = { margin: 0, fontSize: 'clamp(30px,4.6vw,60px)', fontWeight: 800, letterSpacing: '.04em', lineHeight: 1, textTransform: 'uppercase' };

/** The 56px pills: fill (white on black), outline (2px white), ring (the gradient border). */
export const pillBase = { display: 'flex', alignItems: 'center', height: 56, padding: '0 30px', borderRadius: 999, fontSize: 12, fontWeight: 800, letterSpacing: '.18em', textDecoration: 'none', boxSizing: 'border-box', whiteSpace: 'nowrap', textTransform: 'uppercase', fontFamily: MONO };
export const pillFill = { ...pillBase, background: '#fff', color: '#000', transition: 'background-color .2s, color .2s' };
export const pillOutline = { ...pillBase, border: '2px solid #fff', color: '#fff', transition: 'background-color .2s, color .2s' };
export const pillRing = { ...pillBase, border: '2px solid transparent', background: RING_ON, color: '#fff', transition: 'opacity .2s' };

/** The 52px numbered badge on a step (ring border on black). */
export const stepBadge = { display: 'flex', alignItems: 'center', justifyContent: 'center', width: 52, height: 52, border: '3px solid transparent', borderRadius: 999, background: `linear-gradient(#000,#000) padding-box, ${RING_SHORT} border-box`, fontSize: 15, fontWeight: 800, boxSizing: 'border-box' };

/** The 4px progress bar segments (track #2A2A2A, fill #fff). */
export const barTrack = { position: 'relative', flex: 1, height: 4, borderRadius: 999, background: '#2A2A2A', overflow: 'hidden' };
export const barFill = { position: 'absolute', inset: 0, transformOrigin: '0 50%', transform: 'scaleX(0)', background: '#fff', borderRadius: 999 };

/** The phone: 390×844 behind a 3px ring bezel, radius 62 outside / 48 inside. */
export const PHONE_W = 390;
export const PHONE_H = 844;
export const STATUS_H = 47;
export const SCREEN_H = PHONE_H - STATUS_H;
